import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useEffect, useState } from "react";
import "../css/Register.css";
import "../css/SelectRegister.css";
import { useNavigate } from "react-router-dom";

const options = [];

export default function RegisterStudent() {
    const [uniid, setUniid] = useState();
    const [universityName, setUniversityName] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [email, setEmail] = useState();
    const [accountError, setAccountError] = useState();
    const [domain, setDomain] = useState("@domain.edu");
    const [pass, setPass] = useState();
    const [confirmPass, setConfirmPass] = useState();
    const [passError, setPassError] = useState();
    const [target, setTarget] = useState();

    const firstNameFormIndex = 0;
    const lastNameFormIndex = 1;
    const emailFormIndex = 2;
    const passFormIndex = 3;
    const confirmPassFormIndex = 4;

    let navigate = useNavigate();

    useEffect(() => {
        getUniversityOptions();
    }, []);

    useEffect(() => {
        handleChangeUniversity(target);
    }, [target]);

    const redirectLogin = () => {
        navigate("/");
    };

    return (
        <div className="register">
            <div className="ui center aligned padded grid register-box">
                <div className="row">
                    <div className="register-blue-sidebar column five wide">
                        <h2 className="register-app-title">Student Events</h2>
                    </div>
                    <div className="register-form column eleven wide">
                        <h2 className="create-account-heading">
                            CREATE YOUR ACCOUNT
                        </h2>
                        <Form
                            onSubmit={handleSubmit}
                            className="register-register-form"
                        >
                            <Form.Group widths="equal">
                                <Form.Input
                                    fluid
                                    placeholder="First name"
                                    required
                                    onChange={(e) =>
                                        setFirstName(
                                            e.target.form[firstNameFormIndex]
                                                .value
                                        )
                                    }
                                />
                                <Form.Input
                                    fluid
                                    placeholder="Last name"
                                    required
                                    onChange={(e) =>
                                        setLastName(
                                            e.target.form[lastNameFormIndex]
                                                .value
                                        )
                                    }
                                />
                            </Form.Group>
                            <Form.Select
                                required
                                fluid
                                options={options}
                                placeholder="Select Your University"
                                onChange={(e, data) => {
                                    let temp = {};
                                    temp.innerText = data.value.value;
                                    temp.lang = data.value.lang;
                                    temp.id = data.value.uniid;
                                    console.log(temp);
                                    setTarget(temp);
                                }}
                            />
                            <Form.Group className="email" widths="equal">
                                <Form.Input
                                    fluid
                                    placeholder="Email"
                                    required
                                    onChange={(e) =>
                                        setEmail(
                                            e.target.form[emailFormIndex].value
                                        )
                                    }
                                    error={accountError}
                                />
                                {/* Domain changes depending on selected university */}
                                <p className="email-domain">{domain}</p>
                            </Form.Group>
                            <Form.Group widths="equal">
                                <Form.Input
                                    type="password"
                                    fluid
                                    placeholder="Password"
                                    required
                                    onChange={(e) =>
                                        setPass(
                                            e.target.form[passFormIndex].value
                                        )
                                    }
                                    error={passError}
                                />
                                <Form.Input
                                    type="password"
                                    fluid
                                    placeholder="Confirm Password"
                                    required
                                    onChange={(e) =>
                                        setConfirmPass(
                                            e.target.form[confirmPassFormIndex]
                                                .value
                                        )
                                    }
                                    error={!!passError}
                                />
                            </Form.Group>
                            <div className="regstu-button">
                                <Button className="selectreg-btn">REGISTER</Button>
                            </div>
                            <a
                                className="direct-to-login"
                                onClick={redirectLogin}
                            >
                                Already have an account? Login
                            </a>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    );

    // Handle university selection
    async function handleChangeUniversity(uni) {
        // Set the selected university
        setUniversityName(uni.innerText);
        setDomain(uni.lang);
        setUniid(uni.id);
    }

    // Add all universities to options
    async function addToOptions(universities) {
        universities.forEach(function (uni) {
            // options.push({
            //     text: uni.name,
            //     id: uni.uniid,
            //     value: uni.name,
            //     lang: uni.domain,
            //     uniid: uni.uniid
            // });
            options.push({
                text: uni.name,
                id: uni.uniid,
                value: {value: uni.name, lang: uni.domain, uniid: uni.uniid},
            });
        });
    }

    // Connect to API to get University options
    async function getUniversityOptions() {
        try {
            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/listUniversity.php",
                {
                    method: "GET",
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") console.log(res.error);

            addToOptions(res.results);
        } catch (error) {
            console.log(error);
        }
    }

    async function registerStudent() {
        try {
            let info = {
                firstname: firstName,
                lastname: lastName,
                email: email + domain,
                password: pass,
                confirmpassword: confirmPass,
                uniid: uniid,
                adminorsuper: 0,
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/register.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            var res = await response.json();

            if (res.error !== "") {
                console.log(res.error);
                if (res.error !== "User already exists.") {
                    setPassError(res.error);
                } else {
                    setAccountError(res.error);
                }
            }
            else {
                console.log("Successfully registered");
                options.length = 0;
                redirectLogin();
            }
        } catch (error) {
            console.log(error);
        }
    }

    async function handleSubmit() {
        setPassError();
        setAccountError();

        console.log(uniid);
        console.log(universityName);
        console.log(firstName);
        console.log(lastName);
        console.log(email + domain);
        console.log(pass);
        console.log(confirmPass);

        // Call the register API
        registerStudent();
    }
}
